import {combineReducers} from 'redux';


import allLoaders from './loaders';
import custom_snackbar from './snackbar';
import main from './pages/main';
import products from './pages/products';
import categories from './pages/categories';
import productDetails from './pages/products/details';
import aboutUs from './pages/aboutUs';
import contactUs from './pages/contactUs';
import surguryConsultation from './pages/surguryConsultation';
import general from './general';
import modalVideo from './partials/modals/modalVideo';




export default combineReducers({
    allLoaders,
    custom_snackbar,
    main,
    products,
    categories,
    productDetails,
    aboutUs,
    contactUs,
    surguryConsultation,
    general,
    modalVideo,
});
